module.exports = __webpack_public_path__ + "static/media/whiteWhatsApp.2c066e23.svg";